import depositSuccess from "src/assets/deposit-success.svg";

import { Typography } from "antd";
import { Form, Icon, Button } from "src/components";

import {
  DoneContainer,
  DoneFrame,
  DoneText,
  Small,
} from "src/components/SuccessModal/styles/successModal";

import { DASHBOARD } from "src/utils/constants/routes";
import { Button as UIButton } from "src/components/ui";
import { DialogFooter } from "src/components/ui/Modal";
import { ButtonContainer } from "src/pages/LeanDeposit/Details/styles/styleCardSummaryInfo";
import ArrowCircleright from "src/assets/ArrowCircleright.svg";

export const DoneModal = ({ history, asDialog, onClose }) => {
  /* In a dialog the reader is already on the dashboard behind it, so the way
     out is to close — not to navigate to where they are. */
  const onDone = () => (asDialog ? onClose?.() : history.push(DASHBOARD));

  return (
    <DoneContainer
      style={{
        backgroundColor: "#fff",
        justifyContent: "center",
        width: "100%",
        borderRadius: "15px",
      }}
    >
      <img src={depositSuccess} alt="" />
      <Typography.Text type="success" style={{textAlign: "center"}}>
        <DoneFrame>
          <DoneText>{"Deposit request placed successfully"}</DoneText>
        </DoneFrame>
      </Typography.Text>
      <Small>
        {" "}
        <>
          Your cash deposit request has been successfully added!
          <br /> We will update the amount on your account as soon as we receive
          it.
        </>
      </Small>
      {/* Into the dialog's foot band, where the two steps before it put their
          actions. As a full-width slab in the body it was the one screen in
          the flow whose action sat somewhere else.

          The label was missing too — this held the arrow and nothing else, so
          the last thing in the deposit flow was a blue block with a glyph in
          it and no word saying what pressing it does. */}
      {asDialog ? (
        <DialogFooter>
          <ButtonContainer $band={false}>
            <UIButton variant="primary" size="lg" onClick={onDone}>
              Back to dashboard
            </UIButton>
          </ButtonContainer>
        </DialogFooter>
      ) : (
        <DoneFrame width="70%">
          <Button
            key="done"
            onClick={onDone}
            width="80%"
            className="test-success-button"
          >
            <Form.ButtonContainer>
              Back to dashboard
              <Icon size="20px" color="white" src={ArrowCircleright} />
            </Form.ButtonContainer>
          </Button>
        </DoneFrame>
      )}
    </DoneContainer>
  );
};
